window.bz_location_module = angular.module('bzLocationModule', [])
